module.exports = __webpack_public_path__ + "img/intelligent6.95de2615.png";